import { StyledText } from '@goodfynd/typography';
import { Button } from '@goodfynd/ui';

import { styled } from '../../theme/stitches.config';

export const StyledContainer = styled('div', {
  borderRadius: 4,
  padding: 12,
  defaultVariants: { type: 'info' },

  '& [data-icon], & [data-testid^="icon-"]': {
    display: 'flex',
    alignItems: 'center',
  },

  variants: {
    type: {
      error: {
        backgroundColor: 'var(--BackgroundDangerSubtle, #fce3e1)',
        svg: {
          color: 'var(--TextIconDanger)',
        },
        [`${StyledText}`]: {
          color: 'var(--TextIconDanger) !important',
        },
      },
      info: {
        backgroundColor: 'var(--BackgroundInfoSubtle, #defaff)',
        svg: {
          color: 'var(--TextIconInfo)',
        },
        [`${StyledText}`]: {
          color: 'var(--TextIconInfo) !important',
        },
      },
      success: {
        backgroundColor: 'var(--BackgroundFavorableSubtle, #e8fcec)',
        svg: {
          color: 'var(--TextIconFavorable)',
        },
        [`${StyledText}`]: {
          color: 'var(--TextIconFavorable) !important',
        },
      },
      warning: {
        backgroundColor: 'var(--BackgroundWarningSubtle, #fff7bd)',
        svg: {
          color: 'var(--TextIconWarning)',
        },
        [`${StyledText}`]: {
          color: 'var(--TextIconWarning) !important',
        },
      },
    },
  },
});

export const StyledContent = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'relative', // Establishes positioning context for the button
  '@xs': {
    flexWrap: 'wrap',
  },
});

export const StyledBody = styled('div', {
  width: '100%',
  paddingRight: 40, // Make room for the close button
  display: 'block',
  '@xs': {
    width: '100%',
  },
});

export const StyledButton = styled(Button, {
  position: 'absolute',
  marginTop: -4,
  marginRight: -4,
  top: 0,
  right: 0,
  padding: 0,
  minWidth: 'auto',
  height: 'auto',
  border: 'none',
  cursor: 'pointer',
});
